import { RevenueReportPartnerDetailPage } from "@/features/revenue-report-partner/pages/RevenueReportPartnerDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/revenue-report-partner/$id/detail",
)({
	validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
		tab: typeof search.tab === "string" ? search.tab : undefined,
	}),
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["revenue_report_partner.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RevenueReportPartnerDetailPage,
});
